<template>
  <registration-form :alert="alert" :privacy-policy-url="privacyPolicyUrl" @submit="submit" />
</template>

<script>
import { mapMutations } from 'vuex'
import { Api } from '../api/apiAccess'
import RegistrationForm from '../components/RegistrationForm.vue'

export default {
  components: {
    RegistrationForm
  },

  data() {
    return {
      alert: {
        type: 'success',
        text: '',
        dismissible: false,
        isActive: false
      },
      privacyPolicyUrl: ''
    }
  },

  mounted() {
    this.init()
  },

  computed: {
    clubNumber() {
      return this.$route.params['clubNumber']
    }
  },

  methods: {
    ...mapMutations({ updateClubData: 'UPDATE_CLUB_DATA' }),

    init() {
      const ep = Api.PeAn

      ep.peAnGetConfig(this.clubNumber).then(r => {
        if (!r.data.PeAnAktivieren || !r.data.CVPServicesAktivieren) {
          this.alert = {
            type: 'warning',
            text: this.$t('error.noAccess'),
            isActive: true
          }
        } else {
          this.getClubData()
        }
      })
    },

    getClubData() {
      const ep = Api.PublicData

        ep.publicDataGetClubData(150, 150, this.clubNumber).then(r => {
          this.updateClubData(r.data)
          this.privacyPolicyUrl = r.data.APP_DATENSCHUTZBESTURL
        }).catch(() => {
          this.alert = {
            type: 'warning',
            text: this.$t('error.noAccess'),
            isActive: true
          }
        })
    },

    submit(data) {
      data.item.clubNumber = this.clubNumber

      const ep = Api.ApiProxy

      ep.apiApiProxyProxyPostPost({
        'HCaptchaResponse': data.token,
        'ClubNumber': this.clubNumber,
        'Route': 'PeAn/CreateNewClubMembership',
        'RouteParameters': {},
        'BodyParameters': { response: '', addressData: data.item, pdf: data.pdf }
      }).then(r => {
        switch (Number(r.data.cvpApiResponse)) {
          case -2:
            this.alert = {
              type: 'error',
              text: this.$t('registration.invalidIban'),
              isActive: true,
              dismissible: true
            }
            this.alertDismissTimer()
            break
          case -1:
            this.alert = {
              type: 'error',
              text: this.$t('registration.createError'),
              isActive: true
            }
            this.alertDismissTimer()
            break
          case 0:
          case 1:
          case 2:
            this.alert = {
              type: 'success',
              text: this.$t('registration.confirmRegistration'),
              isActive: true
            }
            break
          case 3:
            this.alert = {
              type: 'error',
              text: this.$t('registration.createResult4'),
              isActive: true,
              dismissible: true
            }
            this.alertDismissTimer()
            break
          default:
            this.alert = {
              type: 'error',
              text: this.$t('error.unknownError'),
              isActive: true,
              dismissible: true
            }
        }
      })
    },

    alertDismissTimer() {
      setTimeout(() => {
        this.alert = {
          type: 'warning',
          text: '',
          isActive: false
        }
      }, 10000)
    }
  }
}
</script>